<!--
 * @Author: LHH
 * @Date: 2019-12-18 17:19:13
 -->
<template>
  <header>
    <router-link to="/" class="logo"></router-link>
    <a href="javascript: void(0)" @click="navSwich = !navSwich" :class="['nav-switch']">
      <lottie :options="defOptions" @animCreated="handleAnimation" class="nav-anim"/>
    </a>
    <nav id="nav" :class="{ 'nav-show': navSwich }">
      <router-link to="/">首页</router-link>
      <router-link to="/">产品服务</router-link>
      <router-link to="/about">关于我们</router-link>
      <a href="#">登录</a>
    </nav>
  </header>
</template>

<script>
import Anim from '@lottie/daohang.json'

export default {
  name: 'Header',
  data() {
    return {
      navSwich: false,
      defOptions: {
        animationData: Anim,
        loop: false,
        autoplay: false
      },
      anim: ''
    }
  },
  destroyed() {
    this.anim.destroy()
  },
  watch: {
    navSwich(val) {
      val ? this.anim.playSegments([0, 35], true) : this.anim.playSegments([35, 70], true)
    }
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim
    }
  }
}
</script>

<style lang="less" scoped>
//顶部导航组件
@headHei: 69px;
header {
  width: 100%;
  height: @headHei;
  padding: 0 60px;
  background-color: #ffffff;
  box-shadow: 0 3px 10px 0px rgba(0, 0, 0, 0.12);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  .logo {
    display: block;
    float: left;
    font-size: 20px;
    color: #58595b;
    font-weight: bold;
    width: 126px;
    height: 100%;
    background-image: url('../assets/logo.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
  }
  #nav {
    line-height: @headHei;
    height: @headHei;
    float: right;
    display: flex;
    font-size: 14PX;

    > a {
      display: block;
      height: 100%;
      padding: 0 20px;
      &:hover {
        background-color: #eee;
        color: #517780;
        font-weight: 900;
      }
    }
  }
  .nav-switch {
    display: none;
  }
}
@mobileHeadHei: 50PX;
@media screen and (min-width: 0px) and (max-width: 720px) {
  /deep/ path {
    stroke: rgb(22, 144, 255) !important;
  }
  header {
    height: @mobileHeadHei;
    padding: 12PX;
    > #nav {
      height: 0;
      overflow: hidden;
      transition: .3s;
      transition-delay: .5s;
      position: absolute;
      left: 0;
      top: 100%;
      width: 100%;
      background-color: #ffffff;
      padding: 0;
      display: block;

      > a {
        display: block;
        width: 100%;
        height: @mobileHeadHei;
        line-height: @mobileHeadHei;
        border-bottom: 1PX solid #E3E3E3;
        margin: 0;
        padding: 0 12PX;
        font-size: 16PX;
        color: #8A8A8A;
        font-weight: 400;
      }

      &.nav-show {
        height: 200PX;
        //height: auto;
        padding: 0;
        box-shadow: 0 3px 10px 0px rgba(0, 0, 0, 0.12);
      }
    }
    .logo {
      width: 100%;
      background-size: auto 100%;
      background-position: center left;
    }
    .nav-switch {
      display: flex;
      width: 26PX;
      height: 26PX;
      position: absolute;
      top: 12PX;
      right: 12PX;
      justify-content: center;
      align-items: center;

      .nav-anim {
        width: 150PX !important;
        height: 150PX !important;
        flex-shrink: 0;
      }
    }
  }
}
</style>
